import { useContext } from 'react';

import type {
  SnackbarContextProps as ContextProps,
} from './SnackbarContext';
import SnackbarContext from './SnackbarContext';

export type SnackbarContextProps = ContextProps;

const useSnackbar = () => {
  const snackBarContext = useContext(SnackbarContext);

  return {
    showSnackbar: snackBarContext.showSnackbar,
  };
};

export default useSnackbar;
